export default __webpack_public_path__ + "static/media/Rajendra.1d9c628a.jpeg";